export const NEW_COMPLECTATION = 'new';

const normalizeTitle = (title) => (title || '').toLowerCase().replace(/\s+/g, ' ').trim();

// Вопрос задаётся один на «модель + название из выгрузки»: пятнадцать машин
// «ADVENTURE 1.6» — это один ответ менеджера, а не пятнадцать
export const groupComplectationRows = (rows) => {
  const groups = new Map();
  rows.forEach((row) => {
    const key = `${row.resolvedModelId}|${normalizeTitle(row.complectationName)}`;
    if (!groups.has(key)) {
      groups.set(key, {
        key,
        title: (row.complectationName || '').trim(),
        markName: row.markName,
        modelName: row.modelName,
        candidates: row.complectationCandidates || [],
        suggestedId: row.suggestedComplectationId ?? null,
        rows: [],
      });
    }
    groups.get(key).rows.push(row);
  });
  return Array.from(groups.values());
};

export const candidateLabel = (c) => [c.title, c.engineVolume, c.transmission].filter(Boolean).join(' · ');

export const complectationOptions = (group) => [
  ...group.candidates.map((c) => ({ value: c.id, label: candidateLabel(c) })),
  { value: NEW_COMPLECTATION, label: `＋ Создать новую «${group.title}»` },
];

// Ответ по умолчанию — подсказка бэка (если она однозначна); «создать новую» по
// умолчанию не выбирается никогда, чтобы дубль не заводился одним необдуманным кликом
export const defaultAnswer = (group) =>
  group.suggestedId == null ? null : complectationOptions(group).find((o) => o.value === group.suggestedId) || null;

// Этот шаг решает только комплектацию. Происхождение не шлём (0): бэк запомнит ответ и
// переведёт строку на вкладку происхождения, где оно задаётся и подтверждается явно
export const buildComplectationResolution = (row, answer) => {
  return {
    fileName: row.fileName || null,
    row: row.row,
    markId: row.resolvedMarkId,
    modelId: row.resolvedModelId,
    complectationTitle: row.complectationName || '',
    complectationId: answer.value === NEW_COMPLECTATION ? null : answer.value,
    createComplectation: answer.value === NEW_COMPLECTATION,
    cityId: row.resolvedCityId,
    dcId: row.resolvedDcId,
    vin: row.vin,
    color: row.color || '',
    engineVolume: row.engineVolume || '',
    engineType: row.engineType || null,
    transmission: row.transmission || null,
    priceStr: row.priceStr,
    issueYear: row.yearStr,
    originCarId: 0,
    factoryId: null,
  };
};
